import { useFeatures } from '../context/FeaturesContext';
import { useAuth } from '../hooks/useAuth';
import ComingSoon from '../pages/ComingSoon';

export default function FeatureGate({ feature, children, fallback = null }) {
  const { features, loading } = useFeatures();
  const { user } = useAuth();
  if (loading) return null;
  const flag = features[feature];
  const role = user && user.role;
  if (role === 'admin' || role === 'super_admin') return children;
  if (flag && flag.isEnabled === false) return fallback;
  const visibility = flag ? flag.visibility : 'public';
  if (visibility === 'public') return children;
  if (visibility === 'coming_soon') return <ComingSoon feature={flag} />;
  return fallback;
}
